var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.overlays),function(overlay){return _c('GmapOverlayView',{key:overlay.image,attrs:{"image":overlay.image,"bounds":_vm.getLatLngBounds(overlay.bounds),"is-shown":overlay.isShown}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }